<template>
  <div>
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <div class="container">
      <h3>营销规则详情</h3>
      <el-form :model="marketing" label-position="left" label-width="100px">
        <el-form-item label="规则名称">
          <div>{{ marketing.name }}</div>
        </el-form-item>

        <el-form-item label="营销类型">
          <div v-if="marketing.kind === 0">用户手动领券</div>
          <div v-if="marketing.kind === 1">订单满减</div>
          <div v-if="marketing.kind === 2">订单满赠</div>
          <div v-if="marketing.kind === 3">订单满免运费</div>
        </el-form-item>

        <el-form-item label="仅限新用户" v-if="marketing.kind === 0">
          <div>{{ marketing.newuser === 1 ? '是' : '不是' }}</div>
        </el-form-item>

        <el-form-item label="匹配规则" v-if="marketing.kind !== 0">
          <div v-if="marketing.kind === 1">满 {{ $amount1(marketing.reach) }} 减 {{ marketing.reduction / 100 }}</div>
          <div v-if="marketing.kind === 2 && marketing.gifttype === 0">满 {{ $amount1(marketing.reach) }} 赠优惠券</div>
          <div v-if="marketing.kind === 2 && marketing.gifttype === 1">满 {{ $amount1(marketing.reach) }} 赠商品</div>
          <div v-if="marketing.kind === 3">满 {{ $amount1(marketing.reach) }} 免运费</div>
        </el-form-item>

        <el-form-item label="优惠券模版" v-if="marketing.kind === 0 || (marketing.kind === 2 && marketing.gifttype === 0)">
          <div>
            <span @click="onClickGift(marketing)" class="marketing-link">{{ marketing.coupontemplate.name }}</span>
            <span v-if="marketing.coupontemplate.amountkind === 0"> ({{ `${marketing.coupontemplate.amountbegin / 100}元 ~ ${marketing.coupontemplate.amountend / 100}元` }})</span>
            <span v-if="marketing.coupontemplate.amountkind === 1"> ({{ marketing.coupontemplate.amount / 100 }}元)</span>
          </div>
        </el-form-item>

        <el-form-item label="所赠商品" v-if="marketing.kind === 2 && marketing.gifttype === 1">
          <div>
            <span @click="onClickGift(marketing)" class="marketing-link">{{ marketing.product.name }}</span>
          </div>
        </el-form-item>

        <el-form-item label="有效时间">
          <div v-if="!marketing.begintime || !marketing.endtime">不限制</div>
          <div v-if="marketing.begintime && marketing.endtime">{{ new Date(marketing.begintime * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }} - {{ new Date(marketing.endtime * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>

        <el-form-item label="作用商品" v-if="marketing.kind !== 0">
          <div>
            <div v-if="marketing.producttype === 0">作用于全部商品</div>
            <div v-if="marketing.producttype === 1">作用于部分商品</div>
            <div v-if="marketing.producttype === 2">不作用于部分商品</div>
            <div v-if="marketing.producttype !== 0">
              <span :key="product.id" class="coupon-category" v-for="product in marketing.productlist">{{ product.name }}</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="删除时间" v-if="marketing.deletedat > 0">
          <div>{{ new Date(marketing.deletedat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>

        <el-form-item label="创建时间">
          <div>{{ new Date(marketing.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
export default {
  data() {
    return {
      marketing: {},
      token: ''
    };
  },
  async created() {
    this.token = getToken();
    const res = await rpc(
      'StoreMarketingService.GetMarketing',
      M('IDWithTokenRequest', {
        token: M('Token', { token: this.token }),
        id: this.$route.query.id
      })
    );
    const reslist = await Promise.all([
      res.kind == 0 || (res.kind == 2 && res.gifttype == 0)
        ? rpc(
            'StoreCouponTemplateService.GetCouponTemplate',
            M('IDWithTokenRequest', {
              token: M('Token', { token: this.token }),
              id: res.giftid
            })
          )
        : null,
      res.kind == 2 && res.gifttype == 1
        ? rpc(
            'StoreProductService.GetProduct',
            M('IDWithTokenRequest', {
              token: M('Token', { token: this.token }),
              id: res.giftid
            })
          )
        : null,
      res.categoryidsList.length
        ? rpc(
            'StoreCategoryService.GetCategoryList',
            M('CategoryListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.categoryidsList,
              level: 1,
              count: res.categoryidsList.length,
              sortby: 1
            })
          )
        : null,
      res.productidsList.length
        ? rpc(
            'StoreProductService.GetProductList',
            M('ProductListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.productidsList,
              sortby: 1,
              sort: 1,
              count: res.productidsList.length
            })
          )
        : null
    ]);
    res.coupontemplate = null;
    res.product = null;
    if (res.kind == 0 || (res.kind == 2 && res.gifttype == 0)) {
      res.coupontemplate = reslist[0];
    }
    if (res.kind == 2 && res.gifttype == 1) {
      res.product = reslist[1];
    }
    res.categorylist = res.categoryidsList.map(item => reslist[2].categorylistList.find(v => v.id === item));
    res.productlist = res.productidsList.map(item => reslist[3].productlistList.find(v => v.id === item));
    this.marketing = res;
  },
  methods: {
    onClickGift(marketing) {
      if (marketing.gifttype === 0) {
        this.$router.push({ name: 'marketing-coupon-template-detail', query: { id: marketing.coupontemplate.id } });
      } else {
        this.$router.push({ name: 'products-edit', query: { id: marketing.product.id, type: 'edit' } });
      }
    }
  }
};
</script>

<style>
.coupon-category {
  padding: 4px 8px;
  font-size: 12px;
  background-color: #e9e9e9;
  margin-right: 5px;
}
.marketing-link {
  color: rgb(97, 179, 211);
  cursor: pointer;
}
</style>
